"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _insertNewBlock = _interopRequireDefault(require("./insertNewBlock"));

var insertEmptyBlock = function insertEmptyBlock(editorState) {
  var blockType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'unstyled';
  return (0, _insertNewBlock["default"])(editorState, blockType);
};

var _default = insertEmptyBlock;
exports["default"] = _default;